const JWT_KEY = "syntrofi_jwt";

export interface SyntrofiUser {
  login: string;
  name: string;
  avatar_url: string;
}

export function getJWT(): string | null {
  return localStorage.getItem(JWT_KEY);
}

export function storeJWT(token: string): void {
  localStorage.setItem(JWT_KEY, token);
}

export function removeJWT(): void {
  localStorage.removeItem(JWT_KEY);
}

export function getCurrentUser(): SyntrofiUser | null {
  const token = getJWT();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    if (payload.exp && payload.exp < Date.now() / 1000) {
      removeJWT();
      return null;
    }
    return { login: payload.sub, name: payload.name || payload.sub, avatar_url: payload.ava || "" };
  } catch {
    return null;
  }
}

export function authHeaders(): Record<string, string> {
  const token = getJWT();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
